export function randomId() {
  return Math.round(Math.random() * 0xFFFFFFFF).toString(16);
}
